import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private readonly apiUrl;

  // prettier-ignore
  constructor(
    private http: HttpClient,
  ) {
    this.apiUrl = environment.server;
  }

  get(path: string, params = {}, headers = {}) {
    return this.http.get(`${this.apiUrl}${path}`, { params, headers });
  }

  put(path: string, body = {}, params = {}) {
    return this.http.put(`${this.apiUrl}${path}`, body, { params });
  }

  post(path: string, body?: any, params?: any, headers?: any);
  post(path: string, body?: any, options?: { params?: any; headers?: any });
  post(path: string, body = {}, paramsOrOptions: any = {}, headers = {}) {
    if (arguments.length === 4) {
      // Old signature: post(path, body, params, headers)
      return this.http.post(`${this.apiUrl}${path}`, body, { params: paramsOrOptions, headers });
    } else if (arguments.length === 3 && paramsOrOptions && (paramsOrOptions.headers || paramsOrOptions.params)) {
      // New signature: post(path, body, options)
      return this.http.post(`${this.apiUrl}${path}`, body, paramsOrOptions);
    } else {
      // Old signature: post(path, body, params)
      return this.http.post(`${this.apiUrl}${path}`, body, { params: paramsOrOptions });
    }
  }

  delete(path: string, params = {}, body = {}) {
    return this.http.delete(`${this.apiUrl}${path}`, { params, body });
  }
}
